import { useState } from "react";
import "../styles/cards.scss";

export function HomeCard5(props) {
    const [active, setActive] = useState(false);
    return (
        <div className="homeCard5">
            <div className="top" onClick={() => {
                setActive(!active);
            }}>
                <div className="quest"> {props.quest}</div>
                <div className="arrow" style={{transform: active? "rotate(180deg)" : "rotate(0deg)"}}>&#11167;</div>
            </div>
            <div className="answer" style={{height:active? "100px":"0px"}}> {props.answer}</div>
        </div>
    );
}
